import { useTranslation } from 'react-i18next';

export default function OfferNarrowing() {
  const { t } = useTranslation('common');

  return (
    <section className="py-24 px-8 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
          {t('offer.title')}
        </h2>
        <p className="text-lg text-gray-700 leading-relaxed mb-8">
          {t('offer.description')}
        </p>
        
        <div className="bg-slate-50 rounded-lg p-8 mt-12">
          <h3 className="text-2xl font-semibold text-gray-900 mb-4">
            {t('offer.priority.title')}
          </h3>
          <p className="text-lg text-gray-700 leading-relaxed">
            {t('offer.priority.description')}
          </p>
        </div>
      </div>
    </section>
  );
}
